/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as modalActions from '../../actions/modalActions';

const Modal = (props) => { 
    const {headerText, buttonText, children, text, type, small} = props;
    const hideModal = (e) => {
        props.actions.hideModal();        
    };

    if(props.showModal) {
        return (    
            <div>    
                <div className={`modal fade in ${small ? 'modal-alert': ''}`} id="modal-alert" tabIndex="-1" role="dialog" aria-labelledby="Alert" style={{display:'block'}}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={hideModal} aria-label="Close"><span aria-hidden="true">×</span></button>
                                {headerText ? <h4 className="modal-title" id="myModalLabel">{headerText}</h4> : null}
                            </div>
                            <div className="modal-body">
                                {
                                    text ? 
                                    <div className="msg">
                                        <p>{text}</p>
                                    </div>
                                    :
                                    children
                                }                        
                            </div>
                            {buttonText ?
                                <div className="modal-footer modal-footer-center">
                                    <button type="button" className="btn btn-primary btn-wide" onClick={hideModal}>{buttonText}</button>
                                </div> : null}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" />
            </div>
        );
    }
    else {
        return null;
    }
};

function mapStateToProps(state, ownProps) {
    const showModal = state.modal.showModal && state.modal.modalType == ownProps.type;
    return {         
        showModal
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, modalActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
